import { ConfigProvider, Flex, Input, message } from 'antd'
import locale from 'antd/es/date-picker/locale/ko_KR'
import 'dayjs/locale/ko'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import { createStandaloneRoutineTask } from '../../../api/standalone.api'
import ColorDropDown from '../../../components/apos/ColorDropDown'
import AopsCommonModalLayout from '../../../components/apos/modal/AopsCommonModalLayout'
import { userState } from '../../../store/user'
// import ChecklistSelector from '../ui/ChecklistSelector'
import FormSection from '../ui/FormSection'
import RoutineSelector from '../ui/RoutineSelector'
import SubTaskManager from '../ui/SubTaskManager'

const StandaloneRoutinePopup = ({ open, onClose, onSuccess }) => {
  const [user] = useRecoilState(userState)
  const [formData, setFormData] = useState({
    name: '',
    routineFrequency: null, // 'DAILY', 'WEEKLY', 'MONTHLY'
    routineType: null, // 'DAY_OF_WEEK' or 'DAY_OF_MONTH'
    selectedDaysOfWeek: [], // DayOfWeek 이넘 배열 ['MONDAY', 'TUESDAY', ...]
    dayOfMonth: null, // null or 1-31 숫자
    subTasks: [],
    colorCode: '#FFC700',
  })

  const updateField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }))
  }

  useEffect(() => {
    // 모달이 열릴 때 폼 데이터 초기화
    if (open) {
      setFormData({
        name: '',
        routineFrequency: null,
        routineType: null,
        selectedDaysOfWeek: [],
        dayOfMonth: null,
        subTasks: [],
        colorCode: '#FFC700',
      })
    }
  }, [open])

  const getDayOfMonthError = () => {
    if (
      formData.routineFrequency === 'MONTHLY' &&
      formData.dayOfMonth !== null &&
      formData.dayOfMonth !== ''
    ) {
      const dayNum = parseInt(formData.dayOfMonth, 10)
      if (isNaN(dayNum) || dayNum < 0 || dayNum > 31) {
        return '0-31 사이의 숫자를 입력해주세요'
      }
    }
    return null
  }

  const isFormValid = () => {
    // 업무명 필수
    if (!formData.name || formData.name.trim() === '') {
      return false
    }

    // 루틴 주기 필수
    if (!formData.routineFrequency) {
      return false
    }

    // 주기별 필수 조건 확인
    if (formData.routineFrequency === 'WEEKLY') {
      // 매주인 경우 요일 선택 필수
      if (
        !formData.selectedDaysOfWeek ||
        formData.selectedDaysOfWeek.length === 0
      ) {
        return false
      }
    } else if (formData.routineFrequency === 'MONTHLY') {
      // 매월인 경우 일자 필수 (0-31 범위)
      if (formData.dayOfMonth === null || formData.dayOfMonth === '') {
        return false
      }
      const dayNum = parseInt(formData.dayOfMonth, 10)
      if (isNaN(dayNum) || dayNum < 0 || dayNum > 31) {
        return false
      }
    }
    // DAILY인 경우 추가 조건 없음

    return true
  }

  const createRoutineTask = async () => {
    const param = {
      salusUserId: user.id,
      title: formData.name,
      frequency: formData.routineFrequency, // 'DAILY', 'WEEKLY', 'MONTHLY'
      daysOfWeek:
        formData.routineFrequency === 'WEEKLY'
          ? formData.selectedDaysOfWeek || []
          : [],
      daysOfMonth:
        formData.routineFrequency === 'MONTHLY' &&
        formData.dayOfMonth !== null &&
        formData.dayOfMonth !== ''
          ? [parseInt(formData.dayOfMonth, 10)]
          : [],
      todoItems: formData.subTasks.map((subTask) => subTask.title),
      colorCode: formData.colorCode,
    }

    console.log('param::', param)

    try {
      const res = await createStandaloneRoutineTask(param)
      console.log('createStandaloneRoutineTask res::', res)
      if (res.status === 200) {
        message.success('Routine 업무가 생성되었습니다.')
        onSuccess?.() // refetch tracker board
        onClose()
      } else {
        message.error('Routine 업무 생성에 실패했습니다.')
      }
    } catch (error) {
      console.error('error::', error)
      message.error('Routine 업무 생성에 실패했습니다.')
    }
  }

  return (
    <ConfigProvider
      locale={{
        ...locale,
        DatePicker: locale,
      }}
    >
      <AopsCommonModalLayout
        title={'Routine 업무 생성하기'}
        onClose={onClose}
        open={open}
      >
        <div className="form-container standalone-task-popup">
          <div className="form-wrapper">
            {/* 명칭 입력 */}
            <FormSection
              label="업무 명"
              required
              helperTitle="Routine 업무란?"
              helperDesc="매일·매주·매월 반복되는 놓치면 안 되는 업무 루틴"
            >
              <Flex gap="8px">
                <ColorDropDown
                  value={formData.colorCode}
                  defaultValue={formData.colorCode}
                  onChange={(value) => updateField('colorCode', value)}
                />
                <Input
                  placeholder="업무명을 입력해주세요"
                  className="form-input"
                  value={formData.name}
                  onChange={(e) => updateField('name', e.target.value)}
                />
              </Flex>
            </FormSection>

            {/* 일정 */}
            <FormSection label="일정" required>
              <RoutineSelector
                routineFrequency={formData.routineFrequency}
                routineType={formData.routineType}
                selectedDaysOfWeek={formData.selectedDaysOfWeek}
                dayOfMonth={formData.dayOfMonth}
                onFrequencyChange={(value) =>
                  updateField('routineFrequency', value)
                }
                onTypeChange={(value) => updateField('routineType', value)}
                onDaysOfWeekChange={(value) =>
                  updateField('selectedDaysOfWeek', value)
                }
                onDayOfMonthChange={(value) => updateField('dayOfMonth', value)}
                dayOfMonthError={getDayOfMonthError()}
              />
            </FormSection>

            {/* 체크리스트 */}
            {/* <FormSection
              label={
                <>
                  체크리스트
                  <br />
                  선택
                </>
              }
            >
              <ChecklistSelector
                checklists={checklistData.content}
                value={formData.checklistId}
                onChange={(value) => updateField('checklistId', value)}
                onRefresh={() => getChcecklist(0)}
                onLoadMore={loadMoreChecklists}
                hasMore={
                  (checklistData.pageable?.pageNumber || 0) + 1 <
                  Math.ceil(
                    checklistData.totalElements /
                      (checklistData.pageable?.pageSize || 10),
                  )
                }
                isLoading={isLoadingChecklists}
                onChecklistChanged={() => {
                  setFormData((prev) => ({ ...prev, checklistId: null }))
                }}
              />
            </FormSection> */}

            {/* 하위업무 */}
            <FormSection label="하위업무">
              <SubTaskManager
                subTasks={formData.subTasks}
                onSubTasksChange={(newSubTasks) =>
                  setFormData((prev) => ({ ...prev, subTasks: newSubTasks }))
                }
                subTitle="이 테스크에서 체크해야 할 업무를 적어보세요"
              />
            </FormSection>

            {/* 현재 상태 (이슈 발생) */}
            {/* <FormSection label="현재 상태">
              <div className="status-button-wrapper">
                <div className="status-button-group">
                  <button
                    type="button"
                    className={`status-tag issue-tag ${formData.hasProblem ? 'active' : ''}`}
                    onClick={() =>
                      updateField('hasProblem', !formData.hasProblem)
                    }
                  >
                    <FireFilled className="status-icon" />
                    이슈 발생
                  </button>
                </div>
              </div>
            </FormSection> */}
          </div>
        </div>

        <div className="popup-footer">
          <button className="btn-cancel" onClick={onClose}>
            취소
          </button>
          <button
            className="btn-submit"
            disabled={!isFormValid()}
            onClick={createRoutineTask}
          >
            등록
          </button>
        </div>
      </AopsCommonModalLayout>
    </ConfigProvider>
  )
}

export default StandaloneRoutinePopup
